<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="competencyValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.description')"
                name="description"
                :error="errors.get('description')"
            >
                <textarea class="form-control" rows="10"
                    :placeholder="$t('common.description')"
                    v-model="value.description"
                ></textarea>
            </base-input>

            <base-input class="mb-3"
                :label="$t('competencies.level-n', { level: 1 })"
                name="level1"
                :error="errors.get('rating.1')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('competencies.level-n', { level: 1 })"
                    v-model="value.rating['1']"
                ></textarea>
            </base-input>

            <base-input class="mb-3"
                :label="$t('competencies.level-n', { level: 2 })"
                name="level2"
                :error="errors.get('rating.2')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('competencies.level-n', { level: 2 })"
                    v-model="value.rating['2']"
                ></textarea>
            </base-input>

            <base-input class="mb-3"
                :label="$t('competencies.level-n', { level: 3 })"
                name="level3"
                :error="errors.get('rating.3')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('competencies.level-n', { level: 3 })"
                    v-model="value.rating['3']"
                ></textarea>
            </base-input>

            <base-input class="mb-3"
                :label="$t('competencies.level-n', { level: 4 })"
                name="level4"
                :error="errors.get('rating.4')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('competencies.level-n', { level: 4 })"
                    v-model="value.rating['4']"
                ></textarea>
            </base-input>

            <base-input class="mb-3"
                :label="$t('competencies.level-n', { level: 5 })"
                name="level5"
                :error="errors.get('rating.5')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('competencies.level-n', { level: 5 })"
                    v-model="value.rating['5']"
                ></textarea>
            </base-input>

            <base-input class="mb-3"
                :label="$t('competencies.level-n', { level: 6 })"
                name="level6"
                :error="errors.get('rating.6')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('competencies.level-n', { level: 6 })"
                    v-model="value.rating['6']"
                ></textarea>
            </base-input>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
        },

        created() {
            this.errors.setValidator('competencyValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
